import { gql } from '@apollo/client';

import {
    FR_TASK_FIELDS,
    TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO,
    TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO_LIMITED
} from './task';
import { FR_POINT_FIELDS } from './point';
import { FR_TASK_RESOURCE_FIELDS } from './taskResource';

export const BASIC_LOCATION_FIELDS_FRAGMENT = gql`
    fragment BasicLocationFields on Location {
        Name
        LocationId
        Point {
            ...fr_PointFields
        }
    }
    ${FR_POINT_FIELDS}
`;

export const LOCATION_REMARK_FIELDS_FRAGMENT = gql`
    fragment LocationRemarkFields on LocationRemark {
        LocationRemarkId
        RemarkText
        Archived
        Created
        Location {
            LocationId
        }
        Updated
    }
`;

export const LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO = gql`
    fragment LocationFieldsWithPointsAndTaskInfo on Location {
        LocationId
        Name
        StartDate
        EndDate
        Point {
            ...fr_PointFields
        }
        Task {
            ...TaskFieldsWithStatusAndTypeInfo
        }
        LocationRemark {
            ...LocationRemarkFields
        }
    }
    ${FR_POINT_FIELDS}
    ${TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO}
    ${LOCATION_REMARK_FIELDS_FRAGMENT}
`;

export const LOCATION_FIELDS_WITH_POINTS_AND_TASK_INFO_LIMITED = gql`
    fragment LocationFieldsWithPointsAndTaskInfoLimited on Location {
        LocationId
        Name
        StartDate
        EndDate
        Point {
            ...fr_PointFields
        }
        Task {
            ...TaskFieldsWithStatusAndTypeInfoLimited
        }
        LocationRemark {
            ...LocationRemarkFields
        }
    }
    ${FR_POINT_FIELDS}
    ${TASK_FIELDS_WITH_STATUS_AND_TYPE_INFO_LIMITED}
    ${LOCATION_REMARK_FIELDS_FRAGMENT}
`;

export const FR_PROJECT_LOCATION_FIELDS = gql`
    fragment fr_ProjectLocationFields on Location {
        LocationId
        Name
        StartDate
        EndDate
        Task {
            ...fr_TaskFields
            TaskResource {
                ...fr_TaskResourceFields
            }
        }
    }
    ${FR_TASK_FIELDS}
    ${FR_TASK_RESOURCE_FIELDS}
`;

export const FR_PORTFOLIO_LOCATION_FIELDS = gql`
    fragment fr_PortfolioLocationFields on Location {
        LocationId
        Name
        Task {
            TaskId
            TaskType {
                TaskTypeId
                Abbr
                TaskGroup
                Name
                TaskTypeDetails {
                    TaskTypeDetailsId
                    Origin
                    Code
                }
            }
            TaskStatus {
                TaskStatusId
                Name
            }
        }
        Point {
            ...fr_PointFields
        }
    }
    ${FR_POINT_FIELDS}
`;
